import { ComponentStylesWithFns } from '../../theme/styles.helpers';

export const SurveyStyles: ComponentStylesWithFns = {
  fragebogenRow: {
    backgroundColor: 'white',
    border: '1px solid #dce4ee',
    borderRadius: '12px',
    padding: '0 16px',
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  fragebogenRowText: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#111',
  },
  fragebogenArrow: {
    fontSize: '11px',
    color: '#a0aab9',
  },
  fragebogenContent: {
    backgroundColor: 'white',
    border: '1px solid #dce4ee',
    borderRadius: '12px',
    padding: '16px',
    flexShrink: 0,
  },
  fragebogenItem: {
    marginBottom: '12px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  fragebogenQuestion: {
    fontSize: '11px',
    fontWeight: 700,
    color: '#646e7d',
    marginBottom: '2px',
  },
  fragebogenAnswer: {
    fontSize: '13px',
    color: '#111',
    wordBreak: 'break-word',
    // A multi-select answer is newline separated, one selection per line.
    whiteSpace: 'pre-line',
  },
  previewImageWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    height: '300px',
    marginBottom: '12px',
  },

  imageLoadingWrapper: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    color: 'white',
  },

  thumbnailsWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
    gap: 3,
  },
};
